import type { IconProps } from "./icon.types";

export function AddTemplate({ size = 24, width = size, height = size, ...props }: IconProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.5 5.5V8H20V5.5h2.5V4H20V1.5h-1.5V4H16v1.5zM13.962 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.96h-1.5V18a.5.5 0 0 1-.5.5h-8v-8.008l6.459.022l.005-1.5L5.5 8.976V6a.5.5 0 0 1 .5-.5h7.962zM5.5 10.476V18a.5.5 0 0 0 .5.5h2.5v-8.014z"
      />
    </svg>
  );
}

export default AddTemplate;
